import React from 'react';
import classNames from 'classnames';

export const Indicator: React.FC<{ selected?: boolean }> = ({ selected }) => (
  <div
    className={classNames(
      'w-2 h-2 bg-green-500 rounded-full transition-opacity',
      selected ? 'opacity-100' : 'opacity-30',
    )}
  />
);
